import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MalidCard from './MalidCard';

class KataView extends Component {
	render() {
		return (
			<MalidCard title={window.l('kata_title')}
				count={this.props.count}
				visible={(this.props.data && this.props.data.length > 0)}
				frontPage={this.props.frontPage}
				aboutText={window.l('kata_about')}
				database="kata">
				{
					this.props.data && this.props.data.map(function(item, index) {
						return <p className="card-text" key={index}>
							{
								index > 0 && <hr className="divider"/>
							}
							<a href={'https://islenskordabok.arnastofnun.is/ord/'+item.id}>{item.fletta}</a> {item.ordflokkur}

							{
								item.lidur && item.lidur.length > 0 && <React.Fragment>
									<br/><br/>
									{
										item.lidur.map((lidur, lIndex) => {
											return <div className="lidir" key={lIndex}>
												{
													lIndex > 0 && <hr/>
												}
												<strong>{lidur.numer}</strong> {
													lidur.skyring &&
													lidur.skyring.map((lSkyring, lsIndex) => {
														return <React.Fragment>
															{lSkyring.skyring}<br/>
														</React.Fragment>
													})
												}
												{
													lidur.daemalisti && lidur.daemalisti.map(function(daemi, dIndex) {
														return <React.Fragment key={dIndex}>
															{
																dIndex == 0 && <br/>
															}
															<small>Dæmi: </small><em>{daemi.daemi}</em><br/>
														</React.Fragment>
													})
												}
												{
													lidur.ostaedur && lidur.ostaedur.map(function(ostaeda, oIndex) {
														return <React.Fragment key={oIndex}>
															{
																oIndex == 0 && <br/>
															}
															<em>{ostaeda.ostaeda}</em><br/>
														</React.Fragment>
													})
												}
											</div>
										})
									}
								</React.Fragment>
							}
							{
								item.merking && item.merking.length > 0 && item.merking[0].target_lang != '' && <div className="merking">
									<hr/>
									{
										item.merking.map((merking, mIndex) => {
											return <React.Fragment key={mIndex}>
												{merking.target_lang}<br/><br/>
												{
													merking.daemalisti && merking.daemalisti.length > 0 && merking.daemalisti.map((daemi, dIndex) => {
														return <React.Fragment key={dIndex}>
															<em><strong>{daemi.daemi}</strong></em><br/>
															{daemi.thyding}
														</React.Fragment>
													})
												}

											</React.Fragment>
										})
									}
								</div>
							}
							{
								item.ordasambandalisti && item.ordasambandalisti.length > 0 && <div className="ordasambond">
									<hr/>
									{
										item.ordasambandalisti.map((ordasamband, osIndex) => {
											return <React.Fragment key={osIndex}>
												<em><strong>{ordasamband.ordasamband}</strong></em><br/>
												{ordasamband.thyding}<br/>
											</React.Fragment>
										})
									}
								</div>
							}


							{
								// Eldri útgáfa
							}
							{
								item.skyring && item.skyring.map(function(skyring, skIndex) {
									return <React.Fragment key={skIndex}>
										{skyring.texti}<br/>
									</React.Fragment>
								})
							}
							{
								item.daemi && item.daemi.map(function(daemi, dIndex) {
									return <React.Fragment key={dIndex}>
										<strong><em>{daemi.texti}</em></strong><br/>
									</React.Fragment>
								})
							}
							{
								item.sostaeda && item.sostaeda.map(function(sostaeda, dIndex) {
									return <React.Fragment key={dIndex}>
										{sostaeda.texti}<br/>
										{
											sostaeda.skyring && sostaeda.skyring.map(function(skyring, skIndex) {
												return <div className="ml-4">{skyring.texti}</div>
											})
										}
									</React.Fragment>
								})
							}
							{
								item.ostaeda && item.ostaeda.map(function(ostaeda, dIndex) {
									return <React.Fragment key={dIndex}>
										{ostaeda.texti}<br/>
										{
											ostaeda.skyring && ostaeda.skyring.map(function(skyring, skIndex) {
												return <div className="ml-4">{skyring.texti}</div>
											})
										}
									</React.Fragment>
								})
							}
							<br/><br/><a className="text-light" href={'https://islenskordabok.arnastofnun.is/ord/'+item.id}>{item.fj_merkinga == 1 ? 'Fara í orðabók' : 'Sjá '+item.fj_merkinga+' merkingar í orðabók'}</a>
						</p>
					}.bind(this))
				}
			</MalidCard>
		);
	}
}

export default KataView;



// WEBPACK FOOTER //
// ./src/components/KataView.js